import React from "react";
import { ReactComponent as Cancel } from "../../../Assets/Image/svg/cancel.svg";
import { BtnPrimary } from "../../share/buttons/Btn";
import Inputs from "../../share/input/Inputs";
import { useForm } from "react-hook-form";
import MessageQuill from "../Message/MessageQuill";

const RechargeModal = ({ close, step, setStep }) => {
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm();
  return (
    <div className="relative">
      <button
        onClick={() => {
          close(false);
          setStep(0);
        }}
        className="AddnewsupportTicket-cancel absolute  "
      >
        <div>
          <Cancel />
        </div>
      </button>
      <h3 className="text-center text-[#77498F] mb-16">شارژ کیف پول</h3>
      <form onSubmit={handleSubmit()}>
        <Inputs
          register={{
            required: {
              value: true,
              message: "Enter Name",
            },
          }}
          type="text"
          name="name"
          control={control}
          placeholder="مبلغ مورد نظر*"
          className="border-gray h-[6.4rem] w-full bg-white-dark placeholder-gray text-[1.8rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] mb-[20rem]"
        />
        <BtnPrimary
          className="py-[2rem] px-[10rem] flex mr-auto"
          text="پرداخت"
          onClick={() => setStep(step + 1)}
        />
      </form>
    </div>
  );
};

export default RechargeModal;
